import request from '@/utils/request'

/**
 * 通知消息API接口
 */

/**
 * 获取通知列表（分页）
 * @param {Object} params - { type, readStatus, page, size }
 */
export function getNotificationList(params) {
  return request({
    url: '/notification/list',
    method: 'get',
    params
  })
}

/**
 * 获取未读通知数量（按类型统计）
 */
export function getUnreadCount() {
  return request({
    url: '/notification/unread-count',
    method: 'get'
  })
}

/**
 * 标记单条通知已读
 */
export function markAsRead(id) {
  return request({
    url: `/notification/${id}/read`,
    method: 'put'
  })
}

/**
 * 批量标记已读
 */
export function batchMarkAsRead(ids) {
  return request({
    url: '/notification/batch-read',
    method: 'put',
    data: ids
  })
}

/**
 * 全部标记已读
 */
export function markAllAsRead() {
  return request({
    url: '/notification/read-all',
    method: 'put'
  })
}
